import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheck, FiSave, FiTwitter, FiLinkedin, FiInstagram, FiYoutube } from 'react-icons/fi';

export default function Settings() {
  const [workspaceName, setWorkspaceName] = useState("DigLab Global");
  const [saving, setSaving] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [connections, setConnections] = useState([
    { id: 'Twitter', connected: true },
    { id: 'LinkedIn', connected: true },
    { id: 'Instagram', connected: false },
    { id: 'TikTok', connected: false },
  ]);

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }, 1200);
  };

  const toggleConnection = (id) => {
    setConnections(prev => prev.map(c => c.id === id ? { ...c, connected: !c.connected } : c));
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8 max-w-4xl mx-auto h-full overflow-y-auto relative">
      <AnimatePresence>
        {showToast && (
          <motion.div 
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            className="absolute top-4 left-1/2 -translate-x-1/2 z-50 bg-green-500 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-2"
          >
            <SafeIcon icon={FiCheck} /> Settings updated successfully
          </motion.div>
        )}
      </AnimatePresence>

      <div className="glass-panel p-8 border-[#1a1a1a]">
        <h3 className="text-xl font-medium text-white mb-6 border-b border-[#2a2a2a] pb-4">Workspace Settings</h3>
        <div className="space-y-8">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">Workspace Name</label>
            <input 
              type="text" 
              value={workspaceName}
              onChange={(e) => setWorkspaceName(e.target.value)}
              className="w-full bg-[#141414] border border-[#2a2a2a] rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-[#FF5A5F] transition-colors" 
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">Brand Colors (Primary)</label>
            <div className="flex gap-4">
              <div className="w-10 h-10 rounded-lg bg-[#FF5A5F] border-2 border-white cursor-pointer shadow-[0_0_15px_rgba(255,90,95,0.4)]"></div>
              <div className="w-10 h-10 rounded-lg bg-[#3B82F6] border border-[#2a2a2a] cursor-pointer hover:border-white transition-all"></div>
              <div className="w-10 h-10 rounded-lg bg-[#10B981] border border-[#2a2a2a] cursor-pointer hover:border-white transition-all"></div>
              <div className="w-10 h-10 rounded-lg border border-dashed border-[#444] flex items-center justify-center text-gray-400 cursor-pointer hover:border-[#FF5A5F] hover:text-[#FF5A5F] transition-all">+</div>
            </div>
          </div>

          <div className="pt-6 border-t border-[#2a2a2a]">
            <h4 className="text-md font-medium text-white mb-4">Connected Channels</h4>
            <div className="space-y-3">
              {connections.map((c, i) => (
                <div key={c.id} className="flex items-center justify-between p-4 rounded-lg bg-[#141414] border border-[#2a2a2a] hover:border-[#333] transition-colors">
                  <div className="flex items-center gap-3">
                    <span className="text-sm font-medium text-white">{c.id}</span>
                  </div>
                  <button 
                    onClick={() => toggleConnection(c.id)}
                    className={`text-xs px-4 py-1.5 rounded-full transition-all border ${
                      c.connected 
                      ? 'bg-green-500/10 text-green-400 border-green-500/20' 
                      : 'bg-gray-800 text-gray-400 border-gray-700 hover:border-gray-500'
                    }`}
                  >
                    {c.connected ? 'Connected' : 'Connect'}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="pt-6 flex justify-end gap-4">
            <button className="btn-secondary">Cancel</button>
            <button 
              onClick={handleSave}
              disabled={saving}
              className="btn-primary flex items-center gap-2"
            >
              <SafeIcon icon={saving ? FiCheck : FiSave} className={saving ? 'animate-bounce' : ''} />
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}